import { Seo, orgSchema } from "@/components/layout/Seo";
import { Hero } from "@/components/sections/Hero";
import { Marquee } from "@/components/sections/Marquee";
import { ServicesBento } from "@/components/sections/ServicesBento";
import { Programs } from "@/components/sections/Programs";
import { PinjolSection } from "@/components/sections/PinjolSection";
import { WhySection } from "@/components/sections/WhySection";
import { Timeline } from "@/components/sections/Timeline";
import { AboutTeaser } from "@/components/sections/AboutTeaser";
import { ConsultantStrip } from "@/components/sections/ConsultantStrip";
import { Testimonials } from "@/components/sections/Testimonials";
import { FaqSection } from "@/components/sections/FaqSection";
import { ConsultForm } from "@/components/sections/ConsultForm";

export default function Home() {
  return (
    <>
      <Seo
        title="Mika Solution | Konsultasi Penyelesaian Utang Pinjol, KTA & Kartu Kredit"
        description="Hadapi tagihan pinjol, KTA, atau kartu kredit? Konsultasikan kondisi kewajiban finansial Anda bersama Mika Solution untuk memahami pilihan penyelesaian yang tersedia."
        path="/"
        schema={[orgSchema]}
      />
      <Hero />
      <Marquee />
      <ServicesBento />
      <Programs />
      <PinjolSection />
      <WhySection />
      <Timeline />
      <ConsultantStrip />
      <AboutTeaser />
      <Testimonials />
      <FaqSection />
      <ConsultForm />
    </>
  );
}
